const paymentResponse = {
  UNPROCESSED: null,
  SUCCESS: '00',
  DECLINED_BY_BANK: '101',
};

export default paymentResponse;
